import { TabLink, TabLinkList } from '@/components/TabLink'

import type { DayPanelTab } from './types'

const statusTabIconClassNames: Record<DayPanelTab, string> = {
  scheduled: 'text-fv-orange',
  'in-transit': 'text-fv-beer-dark/60',
  delivered: 'text-fv-green/80',
}

const statusTabOptions: Array<{ id: DayPanelTab; label: string }> = [
  { id: 'scheduled', label: 'Scheduled' },
  { id: 'in-transit', label: 'Picked up' },
  { id: 'delivered', label: 'Delivery' },
]
type Props = {
  activeStatusTab: DayPanelTab
  statusCountsByType: Record<DayPanelTab, number>
  onTabClick: (status: DayPanelTab) => void
}

export const DayStatusNav = ({
  activeStatusTab,
  statusCountsByType,
  onTabClick,
}: Props) => {
  return (
    <nav className="flex items-center justify-center gap-x-2 mb-4 bg-fv-blue/5 border-fv-blue-200 border-b px-4 pt-2 -mx-4 pb-4">
      <TabLinkList className="!gap-0">
        {statusTabOptions.map(option => (
          <TabLink
            key={option.id}
            isActive={option.id === activeStatusTab}
            onClick={() => {
              onTabClick(option.id)
            }}
            className="px-2"
            icon={'circle-dot-sharp-duotone'}
            keepIconColorOnActive
            iconClass={`${statusTabIconClassNames[option.id]} [--fa-primary-color:currentColor] [--fa-secondary-color:#fff] [--fa-secondary-opacity:1]`}
            counter={statusCountsByType[option.id]}
          >
            {option.label}
          </TabLink>
        ))}
      </TabLinkList>
    </nav>
  )
}
